var _circle, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCouponUsage3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.3333,
    cy: 55,
    r: 54.5,
    fill: "white",
    stroke: "#D8E0E7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    transform: "translate(30.3333 30)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9223 55.2243C77.9223 54.6303 78.5365 54.1488 79.2942 54.1488C80.0519 54.1488 80.6662 54.6303 80.6662 55.2243V59.0961C80.6662 59.69 80.0519 60.1715 79.2942 60.1715C78.5365 60.1715 77.9223 59.69 77.9223 59.0961V55.2243Z",
    fill: "url(#paint0_linear_62_578)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0772 55.2243C33.0772 54.6303 32.4629 54.1488 31.7052 54.1488C30.9475 54.1488 30.3333 54.6303 30.3333 55.2243V59.0961C30.3333 59.69 30.9475 60.1715 31.7052 60.1715C32.4629 60.1715 33.0772 59.69 33.0772 59.0961V55.2243Z",
    fill: "url(#paint1_linear_62_578)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4796 52.6431C39.4796 52.0491 38.8653 51.5676 38.1076 51.5676C37.3499 51.5676 36.7357 52.0491 36.7357 52.6431V61.6772C36.7357 62.2712 37.3499 62.7527 38.1076 62.7527C38.8653 62.7527 39.4796 62.2712 39.4796 61.6772V52.6431Z",
    fill: "url(#paint2_linear_62_578)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5198 52.6431C71.5198 52.0491 72.1341 51.5676 72.8918 51.5676C73.6495 51.5676 74.2637 52.0491 74.2637 52.6431V61.6772C74.2637 62.2712 73.6495 62.7527 72.8918 62.7527C72.1341 62.7527 71.5198 62.2712 71.5198 61.6772V52.6431Z",
    fill: "url(#paint3_linear_62_578)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3362 48.3923H60.4402C62.9389 48.3923 64.9644 50.4179 64.9644 52.9165V56.3851H67.9805V52.9165C67.9805 48.7521 64.6046 45.3762 60.4402 45.3762H50.3362C46.1718 45.3762 42.7959 48.7521 42.7959 52.9165V56.3851H45.812V52.9165C45.812 50.4179 47.8376 48.3923 50.3362 48.3923Z",
    fill: "#364858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.812 59.4012H42.7959V63.0206C42.7959 67.185 46.1718 70.5609 50.3362 70.5609H60.4402C64.6046 70.5609 67.9805 67.185 67.9805 63.0206V59.4012H64.9644V63.0206C64.9644 65.5192 62.9389 67.5447 60.4402 67.5447H50.3362C47.8376 67.5447 45.812 65.5192 45.812 63.0206V59.4012Z",
    fill: "#364858"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2806 56.2328C49.2806 55.7339 49.685 55.3294 50.1839 55.3294H52.1474C52.6463 55.3294 53.0507 55.7339 53.0507 56.2328V59.7043C53.0507 60.2032 52.6463 60.6076 52.1474 60.6076H50.1839C49.685 60.6076 49.2806 60.2032 49.2806 59.7043V56.2328Z",
    fill: "#364858"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5749 56.2328C57.5749 55.7339 57.9794 55.3294 58.4783 55.3294H60.4417C60.9406 55.3294 61.3451 55.7339 61.3451 56.2328V59.7043C61.3451 60.2032 60.9406 60.6076 60.4417 60.6076H58.4783C57.9794 60.6076 57.5749 60.2032 57.5749 59.7043V56.2328Z",
    fill: "#364858"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7988 42.3502H56.4885V47.3323H53.7988V42.3502Z",
    fill: "#364858"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9858 43.3892C57.4046 43.3892 59.3655 41.4283 59.3655 39.0094C59.3655 36.5905 57.4046 34.6296 54.9858 34.6296C52.5669 34.6296 50.606 36.5905 50.606 39.0094C50.606 41.4283 52.5669 43.3892 54.9858 43.3892ZM54.2284 37.2312L54.2284 38.252H53.2075C52.7892 38.252 52.4501 38.5911 52.4501 39.0094C52.4501 39.4277 52.7892 39.7668 53.2075 39.7668L54.2284 39.7668V40.7877C54.2284 41.206 54.5675 41.5451 54.9858 41.5451C55.4041 41.5451 55.7432 41.206 55.7432 40.7877L55.7432 39.7668H56.764C57.1823 39.7668 57.5214 39.4277 57.5214 39.0094C57.5214 38.5911 57.1823 38.252 56.764 38.252L55.7432 38.252V37.2312C55.7432 36.8129 55.4041 36.4738 54.9858 36.4738C54.5675 36.4738 54.2284 36.8129 54.2284 37.2312Z",
    fill: "#364858"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6938 69.6138C52.3077 69.6138 51.9948 69.9268 51.9948 70.3129V74.601C51.9948 75.1631 52.6242 75.4954 53.0843 75.1728C54.8282 73.95 56.7185 72.5189 58.4604 70.7393C58.8794 70.3112 58.5663 69.6138 57.9673 69.6138H52.6938Z",
    fill: "#364858"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_578",
    x1: 30.3333,
    y1: 49.6702,
    x2: 124.238,
    y2: 59.4013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AD0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9429FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_62_578",
    x1: 30.3333,
    y1: 49.6702,
    x2: 124.238,
    y2: 59.4013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AD0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9429FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_62_578",
    x1: 30.3333,
    y1: 49.6702,
    x2: 124.238,
    y2: 59.4013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AD0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9429FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_62_578",
    x1: 30.3333,
    y1: 49.6702,
    x2: 124.238,
    y2: 59.4013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AD0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9429FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponUsage3);
export default __webpack_public_path__ + "static/media/coupon_usage_3.b71a447e47e926c4e5ad477e122cf7c8.svg";
export { ForwardRef as ReactComponent };